import { render, staticRenderFns } from "./cliente.vue?vue&type=template&id=b017ab5c"
import script from "./cliente.vue?vue&type=script&lang=js"
export * from "./cliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports